import Radar from"@fusioncharts/powercharts/src/chart/radar";export default Radar;